import { useToggle } from 'react-use';
import { Icon } from '@zenid/web';
import type { AccountSchema } from '@zenid/mypage-api';
import { flex } from '../../../../../../styled-system/patterns';
import { Organization } from '../Organization';

export type PastOrganizationsProps = {
  showOrganizations: boolean;
} & Pick<AccountSchema, 'pastMemberships'>;

export function PastOrganizations({ showOrganizations, pastMemberships }: PastOrganizationsProps) {
  const [on, toggle] = useToggle(true);
  return (
    <div
      className={flex({
        border: '1px solid {colors.border.light}',
        borderTop: 'none',
        borderRadius: '0 0 {radii.16} {radii.16}',
        background: '{gradients.background.gradation}',
        flexDirection: 'column',
      })}
    >
      <button
        className={flex({
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '{spacing.12} {spacing.16}',
          sm: {
            padding: '{spacing.16} {spacing.24}',
          },
          _hover: {
            cursor: 'pointer',
          },
        })}
        onClick={() => toggle()}
      >
        <h3
          className={flex({
            textStyle: 'headding.xs.regular',
            sm: {
              textStyle: 'headding.s.regular',
            },
          })}
        >
          過去に所属していた組織
        </h3>
        {on ? <Icon name="expand_more" size="m" /> : <Icon name="expand_more" size="m" />}
      </button>
      {on &&
        showOrganizations &&
        pastMemberships.map((membership) => {
          return <Organization key={membership.organization.id} membership={membership} />;
        })}
    </div>
  );
}
